module.exports = __webpack_public_path__ + "img/logo_image.c5c00369.png";